// extracted by mini-css-extract-plugin
export default {"backTop":"backTop--tb87j","article":"article--3xhph","code":"code--12gh2","block":"block--30AJa","backBottom":"backBottom--2IEsv"};